import React from 'react';
import { CloudImage } from '@components/CloudImage';
import { useOurValuesController } from './OurValues.controllers';
import {
  StyledContainer,
  WrapperBox,
  StyledCloudImage,
  Heading,
  StyledTextPairing,
  StyledColumns,
  StyledColumn,
  StyledBox,
  ValueTextPairing,
  ForegroundBox,
  ForegroundGridBox,
} from './OurValues.styles';
import { useTranslation } from 'react-i18next';
import { JoykitIconVariant } from '@components/JoykitIcon';

export const OurValuesDesktop: React.FC = () => {
  const { t } = useTranslation('careers');
  const ourValuesData = t('ourValues');
  const { containerRef, assetsRef } = useOurValuesController();
  return (
    <StyledContainer>
      <WrapperBox ref={containerRef} paddingTop={11} paddingBottom={[11, 12, 14]}>
        <StyledCloudImage src="careers/values/bg-gradients.png" width="100%" />
        <Heading paddingX={7}>
          <StyledTextPairing
            eyebrow={ourValuesData.eyebrow}
            eyebrowVariant="sectionEyeBrow24"
            eyebrowColor={'humana4'}
            eyebrowTagName="h3"
            title={ourValuesData.title}
            titleVariant="hed56"
            titleColor={'neutra6'}
            titleTagName="h3"
            body={ourValuesData.body}
            bodyVariant="dek20"
            bodyColor={'neutra5'}
            textAlign="center"
            alignment={'center'}
          />
        </Heading>
        <StyledColumns multiline stackOnMobile={false}>
          {ourValuesData.values.map((value, index: number) => (
            <StyledColumn key={index} tablet={6} desktop={4} mobile={6}>
              <StyledBox marginTop={[0, 10]} paddingY={10}>
                <ValueTextPairing
                  icon={value.icon as JoykitIconVariant}
                  iconColor="mono1"
                  iconSize={40}
                  title={value.title}
                  titleVariant="calloutDek40"
                  titleColor="neutra6"
                  titleMaxWidth={index === 3 ? '197px' : '245px'}
                  titleTagName="h3"
                  body={value.body}
                  bodyVariant="featureCopy17"
                  bodyColor="neutra5"
                  bodyMaxWidth="245px"
                />
              </StyledBox>
            </StyledColumn>
          ))}
        </StyledColumns>
        <ForegroundGridBox>
          <CloudImage src={'careers/values/fg-grid-v4.svg'} width="100%" />
        </ForegroundGridBox>
        <ForegroundBox ref={assetsRef}>
          <CloudImage src={'careers/values/fg-curls-v2.svg'} width="100%" />
        </ForegroundBox>
      </WrapperBox>
    </StyledContainer>
  );
};
